import React, { createContext, useContext } from 'react';
import TicketAudit from '../components/TicketAudit';

const TicketAuditContext = createContext();

export function useTicketAuditContext() {
  return useContext(TicketAuditContext);
}

const TicketAuditApp = (props) => (
  <TicketAuditContext.Provider value={props}>
    <TicketAudit />
  </TicketAuditContext.Provider>
);

export default TicketAuditApp;
